import React from 'react'
import {GetCartDetailsQuery} from '@data/__generated__/types.main'

export default React.createContext<GetCartDetailsQuery['preferences']['cart']['items'][number]>(
  null
)
